import { strings as stringManager } from '../../Strings';
export const moduleName = 'eeCompensationCard';
stringManager.load(moduleName, {
    cardTitle: 'Base Pay',
    noPayData: 'There is no pay data for this employee',
    notApplicable: 'N/A',
    payEffectiveDate: 'Pay Effective Date',
    perHour: '/hr'
});
const moduleStrings = stringManager[moduleName];
export { moduleStrings as strings };
export default moduleStrings;
